import { stringify } from "qs";
import request from "../utils/request";

export async function getList(params) {
  return request(`/product/attributes?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/product/attributes/${id}`, { params });
}

export async function create(body) {
  return request(`/product/attributes`, {
    method: "POST",
    body,
  });
}

export async function update(id, body) {
  return request(`/product/attributes/${id}`, {
    method: "POST",
    body,
  });
}
